import 'remodal';
import { codeToRole, toleToCode } from 'config/constants';
import { redirect } from 'utils/helpers';
import loaderHtml from 'components/loader';

'use strict';

const People = {

    /**
     * Initialize the people features
     */
    init(options) {
        this.options = options || {};

        this.$personClone = $('.person-clone').clone().removeClass('hidden').removeClass('.person-clone');
        this.$flagClone = this.$personClone.find('.sprite-container').remove();
        $('.person-clone').remove();
        this.$changeRoles = $('#change-roles');
        this.$changeRoles.append(`<div class="loader-overlay">${loaderHtml}</div>`);
        this.$changeRolesModal = this.$changeRoles.remodal({ hashTracking: false });

        if (this.options.permissions.isAdmin || (this.options.permissions.isManager && this.options.isCityMember)) {
            const editRole = '<i class="fa fa-pencil js-person-edit-role" aria-hidden="true"></i>';

            this.$personClone.find('.js-person-invite').addClass('hidden');
            this.$personClone.find('.person__role').append(editRole);
            this.initUserRole('#change-user-roles', '.change-user-roles-control');
        }

        if (this.options.permissions.isLoggedIn) {
            this.$personClone.find('.js-person-profile').removeClass('hidden');
        }

        this.bindEvents();
    },

    initUserRole(elem, elemRootParent) {
        let options = '';
        const userRoles = [
            { name: 'User', CMOnly: true },
            { name: 'City Manager', CMOnly: false },
            { name: 'Supplier', CMOnly: false },
            { name: 'Photographer', CMOnly: true },
            { name: 'Event Manager', CMOnly: true },
            { name: 'Ambassador', CMOnly: true }
        ];

        for (let role of userRoles) {
            if (this.options.permissions.isAdmin === true ||
                (this.options.permissions.isManager === true && role.CMOnly === true)) {
                options += `<option value="${role.name}">${role.name}</option>`;
            }
        }

        $(elem).append(options);
        $(elem).customSelect('init');

        $(elemRootParent).find('div.select-box__display').text('');
        $(elemRootParent).find('a.active').removeClass('active');
    },

    openChangeRoles(e) {
        e.preventDefault();
        e.stopPropagation();
        const $elem = $(e.target).siblings('.js-person-role')[0];
        let role = $($elem).data('role');

        if ((this.options.permissions.isManager && this.options.isCityMember) && (role == 4 || role == 3)) {
            $.snackbar({ content: 'You can not change the Admin or Supplier role' });
            return;
        }

        this.editingUserId = $($elem).data('userid');
        this.$changeRolesModal.open();
    },

    closeChangeRoles(e) {
        e.preventDefault();

        $('.change-user-roles-control').find('div.select-box__display').text('');
        $('.change-user-roles-control').find('a.active').removeClass('active');
        $('.change-user-roles-control').addClass('is-empty');

        this.$changeRolesModal.close();
    },

    editUserRoles(e) {
        const newRole = $('#change-user-roles').children('option:selected').text();
        const data = {
            'role_type': toleToCode[newRole]
        };

        this.$changeRoles.addClass('is-loading');

        window.Api.User.updateRole(this.editingUserId, data)
            .then((resp) => {
                this.$changeRoles.removeClass('is-loading');

                $('.change-user-roles-control').find('div.select-box__display').text('');
                $('.change-user-roles-control').find('a.active').removeClass('active');
                $('.change-user-roles-control').addClass('is-empty');

                this.$changeRolesModal.close();
                location.reload();
            }, () => {
                $.snackbar({ content: 'We couldn\'t change the role. Please try again later!' });
                this.$changeRoles.removeClass('is-loading');
            });
    },

    /**
     * Get list of people nodes
     * @param peopleArr
     * @returns {Array}
     */
    getPeople(peopleArr) {

        let $people = [];

        for (let i in peopleArr) {
            let $clone = this.$personClone.clone();
            let $flags = [];

            $clone.addClass(`--c${(Math.floor(Math.random() * 5) + 1)}`);
            $clone.find('.js-person-image').prop('src', peopleArr[i].avatar);
            $clone.find('.js-person-name').text(`${peopleArr[i].first_name} ${peopleArr[i].last_name}`);
            $clone.find('.js-person-role').attr('data-userid', peopleArr[i].id);
            $clone.find('.js-person-role').text(codeToRole[peopleArr[i].role_type]);
            $clone.find('.js-person-role').data('role', peopleArr[i].role_type);

            for (let c in peopleArr[i].flags) {
                let $fClone = this.$flagClone.clone();
                $fClone.find('.sprite').addClass(`sprite2-${peopleArr[i].flags[c].image}`);
                $flags.push($fClone);
            }

            $clone.find('.js-person-languages').append($flags);

            if (this.options.permissions.isLoggedIn && typeof peopleArr[i].invite === 'string' && this.options.isCityMember) {
                if (peopleArr[i].invite.length && !peopleArr[i].inviteAll) {
                    $clone.find('.js-person-invite').removeClass('hidden').data('email', peopleArr[i].email).data('eventId', peopleArr[i].invite);
                }
                else if (!peopleArr[i].inviteAll) {
                    $clone.find('.js-person-invited').removeClass('hidden');
                }
            }
            else if (this.options.permissions.isLoggedIn && typeof peopleArr[i].inviteAll && this.options.isCityMember) {
                $clone.find('.js-person-invite-all').removeClass('hidden');
            }

            if (this.options.permissions.isLoggedIn) {
                $clone.data('user', peopleArr[i]);
                $clone.data('url', `profile/${peopleArr[i].id}`);
                $clone.addClass('js-user-link');
                $clone.find('.js-person-profile').attr('href', `/profile/${peopleArr[i].id}`);
            }

            $people.push($clone);
        }

        return $people;
    },

    visitProfile(e) {
        e.preventDefault();

        const url = $(e.target).closest('.person').data('url');

        redirect(url);
    },

    invitePerson(e) {
        e.preventDefault();
        e.stopPropagation();
        let $elem = $(e.target).closest('a');

        window.Api.Event.invite($elem.data('eventId'), {
            email: $elem.data('email'),
            'city_id': this.options.city.id
        }).then((res) => {
            if (res.isOk) {
                $.snackbar({ content: 'User Invited!' });
                $elem.addClass('hidden');
                $elem.siblings('.js-person-invited').removeClass('hidden');
            }
            else {
                $.snackbar({ content: 'We couldn\'t invite user at the moment. Please try again later!' });
            }
        }, () => {
            $.snackbar({ content: 'We couldn\'t invite user at the moment. Please try again later!' });
        });
    },

    inviteAllPerson(e) {
        e.preventDefault();
        e.stopPropagation();

        this.options.openInviteAllModal($(e.target).closest('.person').data('user'));
    },

    bindEvents() {
        $(document).on('click', '.js-person-invite', this.invitePerson.bind(this));
        $(document).on('click', '.js-person-invite-all', this.inviteAllPerson.bind(this));
        $(document).on('click', '.js-person-edit-role', this.openChangeRoles.bind(this));
        $(document).on('click', '.js-user-link', this.visitProfile.bind(this));
        this.$changeRoles.on('click', '.js-close-change-roles', this.closeChangeRoles.bind(this));
        this.$changeRoles.on('click', '.js-submit-role', this.editUserRoles.bind(this));

    }
};


export default People;
